(function () {
  'use strict';

  function initCollectionListSliders() {
    const sliders = document.querySelectorAll('.ccl-inner');

    sliders.forEach(function (slider) {
      // Avoid double-init
      if (slider._cclSwiper) {
        slider._cclSwiper.destroy(true, true);
        slider._cclSwiper = null;
      }

      const desktopSlider  = slider.dataset.desktopSlider  === 'true';
      const mobileSlider   = slider.dataset.mobileSlider   === 'true';
      const slidesDesktop  = parseFloat(slider.dataset.slidesDesktop)  || 4;
      const slidesMobile   = parseFloat(slider.dataset.slidesMobile)   || 1.5;
      const gap            = parseInt(slider.dataset.gap, 10)           || 16;
      const loop           = slider.dataset.loop       === 'true';
      const autoplay       = slider.dataset.autoplay   === 'true';
      const autoplayDelay  = parseInt(slider.dataset.autoplayDelay, 10) || 3000;
      const showPagination = slider.dataset.showPagination === 'true';

      if (typeof Swiper === 'undefined') return;

      const swiperOptions = {
        // Mobile default
        slidesPerView: mobileSlider ? slidesMobile : 'auto',
        spaceBetween: gap,
        loop: loop,
        watchOverflow: true,
        grabCursor: true,

        // Navigation arrows
        navigation: {
          nextEl: slider.querySelector('.swiper-button-next'),
          prevEl: slider.querySelector('.swiper-button-prev'),
        },

        // Pagination dots
        pagination: showPagination
          ? {
              el: slider.querySelector('.ccl-pagination'),
              clickable: true,
              dynamicBullets: true,
            }
          : false,

        // Autoplay
        autoplay: autoplay
          ? { delay: autoplayDelay, disableOnInteraction: false, pauseOnMouseEnter: true }
          : false,

        // Desktop breakpoint
        breakpoints: {
          750: {
            slidesPerView: desktopSlider ? slidesDesktop : 'auto',
            spaceBetween: gap,
            enabled: desktopSlider,
          },
        },

        // Mobile: only enable if mobileSlider is true
        enabled: mobileSlider || window.innerWidth >= 750,
      };

      const swiperInstance = new Swiper(slider, swiperOptions);
      slider._cclSwiper = swiperInstance;
    });
  }

  // Init on DOM ready
  document.addEventListener('DOMContentLoaded', initCollectionListSliders);

  // Re-init when Shopify loads a section in the editor
  document.addEventListener('shopify:section:load', function (e) {
    const section = e.target;
    const slider  = section ? section.querySelector('.ccl-inner') : null;
    if (slider && slider._cclSwiper) {
      slider._cclSwiper.destroy(true, true);
      slider._cclSwiper = null;
    }
    initCollectionListSliders();
  });

  document.addEventListener('shopify:section:unload', function (e) {
    const section = e.target;
    const slider  = section ? section.querySelector('.ccl-inner') : null;
    if (slider && slider._cclSwiper) {
      slider._cclSwiper.destroy(true, true);
      slider._cclSwiper = null;
    }
  });
})();
